var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BookModelCollection } from "../BookModelCollection";
var FormItemModelCollection = /** @class */ (function (_super) {
    __extends(FormItemModelCollection, _super);
    function FormItemModelCollection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormItemModelCollection.prototype.getFields = function (form, validationErrors, prefix, fieldIndex, component) {
        if (prefix === void 0) { prefix = ""; }
        if (fieldIndex === void 0) { fieldIndex = null; }
        var fields = (this.all())
            .reduce(function (allFields, formItem) {
            var _a;
            var entityName = formItem.get("entity_name");
            if (entityName === "formGroup") {
                return allFields.concat(formItem.formGroup().getFormGroup(form, validationErrors, component));
            }
            var parentName = formItem.getItemName(prefix, fieldIndex);
            var validationPrefix = form && entityName !== "consent" && form.participantIndices && fieldIndex ? formItem.getItemName(prefix, form.participantIndices["" + fieldIndex]) : parentName;
            return allFields.concat((_a = formItem[entityName]()) === null || _a === void 0 ? void 0 : _a.getField(form, validationErrors, { prefix: parentName, index: fieldIndex, validationPrefix: validationPrefix }));
        }, [])
            .filter(Boolean);
        return fields;
    };
    return FormItemModelCollection;
}(BookModelCollection));
export { FormItemModelCollection };
